// extracted by mini-css-extract-plugin
export var link = "change-language-module--link--qzCWY";